<template>
<div>
    <div class="mcc-page-header" fixed="" compact="">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mcc-row">
                <section class="mcc-col mu-d-flex mu-flex-row">

                    <h1 class="mu-mb-00">Instances</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section class="mcc-col mu-d-flex mu-justify-content-end mu-align-items-center">

                    <div role="group" class="mcc-button-group">
                        <router-link :to="CONTEXT_PATH + '/processengine/processes/customview/new'">
                            <button class="mcc-button mcc-button--primary" id="createCustomViewBtn" title="Create custom view">
                                <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Create custom view</span>
                            </button>
                        </router-link>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb" class="">
            <ol class="mcc-breadcrumb">
                <li>Process engine</li>
                <li>Instances</li>
            </ol>
        </nav>
        <div class="mcc-card">
            <div class="mcc-card__body">
                <div v-if="!fetchCall" class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
                <Drawer ref="customFilter" @reset-filter=" resetFilter" @apply-filter="submitDialog($event)" title="Instance Filters">
                  
                        <section class="mcc-card mu-border-0">
                            <form id="formIdd">
                            <div class="mcc-row" v-show="!updateDialog">
                                <div class="mfc-slim-select-wrapper mu-mb-05 ">
                                    <label for="process">Process</label>
                                    <select id="process" @change="processNameRef = $event.target.value" name="process">
                                        <option value :selected="processNameRef ==''" data-placeholder="true"></option>
                                        <option v-for="(proc,key) in uniqueProcesses" :selected="processNameRef == proc" :key="key" :value="proc">{{proc}}</option>
                                    </select>
                                </div>
                                <div class="mcc-segmented-buttons mcc-segmented-buttons--sm  mu-mb-05 mfc-form-input-container">
                                    <fieldset class="mfc-fieldset">
                                        <legend class="mfc-label">
                                            Status
                                        </legend>
                                        <div class="mcc-segmented-buttons__list " size="sm">
                                            <input type="radio" value="running" id="day" name="statusRadio" @click="statusRef = $event.target.value" :checked="statusRef =='running'">
                                            <label class="mcc-segmented-buttons__button" for="day">
                                                <span class="mcc-segmented-buttons__label">Running</span>
                                            </label>
                                            <input type="radio" value="completed" id="week" name="statusRadio" @click="statusRef = $event.target.value" :checked="statusRef =='completed'">
                                            <label class="mcc-segmented-buttons__button" for="week">
                                                <span class="mcc-segmented-buttons__label">Completed</span>
                                            </label>
                                            <input type="radio" value="all" id="month" name="statusRadio" @click="statusRef = $event.target.value" :checked="statusRef =='all'">
                                            <label class="mcc-segmented-buttons__button" for="month">
                                                <span class="mcc-segmented-buttons__label">All</span>
                                            </label>
                                        </div>
                                        <div class="mfc-invalid-feedback mfc-invalid-feedback--show"></div>
                                    </fieldset>
                                </div>
                                <div class="mfc-slim-select-wrapper mu-mb-05 ">
                                    <label for="startedByUser" >Started by</label>
                                    <select @change="startedByRef = $event.target.value" name="startedByUser" id="startedByUser" >
                                        <option value :selected="startedByRef ==''" data-placeholder="true"></option>
                                        <option v-for="(user,key) in allUsers" :selected="startedByRef == user.username" :key="key" :value="user.username">{{user.firstName}} {{user.surname}}</option>
                                    </select>
                                </div>
                                <div class="mfc-slim-select-wrapper mu-mb-05 ">
                                    <label for="involving" >Involving</label>
                                    <select @change="involvingRef = $event.target.value" name="involving" id="involving" >
                                        <option value :selected="involvingRef ==''" data-placeholder="true"></option>
                                        <option v-for="(user,key) in allUsers" :selected="involvingRef == user.username" :key="key" :value="user.username">{{user.firstName}} {{user.surname}}</option>
                                    </select>
                                </div>
                                <div class="flatpickr mfc-input-wrapper mfc-input-wrapper--width " ref="createdDate">
                                    <label for="inputGroupDefault1">Started between</label>
                                    <div class="mfc-input-group flatpickr-date--width mfc-input-group--has-help-text mfc-input-group--has-validation-text startFlatDiv" id="CreatedateSelect">
                                        <input type="text" placeholder="Select Date.." data-input ref="createdDateinput" name="createdDate" id="createdDateId" prepend icon="calendar" @change="handleStartRangeChange($event)" @ready="handleStartRangeReady()" style="color: black;">
                                        <button type="button" class="mcc-button mcc-button--outline mcc-button--icon-only" data-toggle>
                                            <mcc-icon aria-hidden="true" name="calendar"></mcc-icon>
                                        </button>
                                    </div>
                                </div>
                                <div class="flatpickr mfc-input-wrapper mfc-input-wrapper--width mu-mt-04 " ref="updatedDate">
                                    <label for="inputGroupDefault1">Completed between</label>
                                    <div class="mfc-input-group flatpickr-date--width mfc-input-group--has-help-text mfc-input-group--has-validation-text endFlatDiv" id="UpdatedateSelect">
                                        <input type="text" placeholder="Select Date.." data-input ref="updatedDateInput" name="updatedDate" id="updatedDateId" prepend icon="calendar" @change="handleEndRangeChange($event)" @ready="handleEndRangeReady()" style="color: black;">
                                        <button type="button" class="mcc-button mcc-button--outline mcc-button--icon-only" data-toggle>
                                            <mcc-icon aria-hidden="true" name="calendar"></mcc-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        </section>
                   
                </Drawer>
                <div class="mcc-row" v-if="fetchCall">
                    <div class="mcc-col">
                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            
                            <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                    <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                    <span class="mcc-button__label">Filters {{filterCount > 0 ? ` (${filterCount})` : '(1)'}}</span>
                                </button>
                            </div>
                            <mcc-data-table ref="instTable" id="instTableId"></mcc-data-table>
                                
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import InstanceAPI from "../../../services/InstanceAPI";
import Utils from "@/script_utils";
import Drawer from "../../common/Drawer.vue";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';
export default {
    name: "InstanceList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["processengine.instances.list"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            instances: {},
            updateDialog: false,
            processName: "",
            processNameRef: "",
            status: "running",
            statusRef: "running",
            startedBy: "",
            startedByRef: "",
            involving: "",
            involvingRef: "",
            startedAfter: "",
            startedBefore: "",
            finishedAfter: "",
            finishedBefore: "",
            startDateRangeRef: [],
            endDateRangeRef: [],
            category: "",
            uniqueProcesses: {},
            allUsers: {},
            categoryRef: "",
            tableObj: null,
            currentPageSize: 10,
            tableData: [],
            filterCount: 0,
            updateCall: true,
            filterActive: false,
            createdDateFlatPickrInstance: null,
            updatedDateFlatPickrInstance: null,
            fetchCall: false,
            filterData: [],
        };
    },

    updated() {
        this.flatpickr()
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        let processType = localStorage.getItem("processType");
        if (processType != null && processType != "") {
            self.statusRef = processType;
            self.status = processType;
            localStorage.removeItem("processType");
        }
        if (localStorage.getItem("instanceList") == "instanceList") {
            let storedProcessName = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_processName"
            );

            if (storedProcessName != null) {
                this.processNameRef = storedProcessName;
                this.processName = storedProcessName;
            }

            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_processName"
            );

            let storedStatus = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_status"
            );
            if (storedStatus != null) {
                this.statusRef = storedStatus;
                this.status = storedStatus;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_status"
            );

            let storedStartedBy = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_startedBy"
            );
            if (storedStartedBy != null) {
                this.startedBy = storedStartedBy;
                this.startedByRef = storedStartedBy;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_startedBy"
            );

            let storedInvolving = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_involving"
            );
            if (storedInvolving != null) {
                this.involving = storedInvolving;
                this.involvingRef = storedInvolving;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_involving"
            );

            let storedStartDate = localStorage
                .getItem(
                    "DataTables_" + window.location.pathname + "_startDateRangeRef"
                );
            if (storedStartDate != null) {
                let startDateRangStringArr = storedStartDate
                    .split(",");
                if (startDateRangStringArr.length > 1) {
                    this.startDateRangeRef[0] = new Date(startDateRangStringArr[0]);
                    this.startDateRangeRef[1] = new Date(startDateRangStringArr[1]);
                }
            }
            let storedEndDate = localStorage
                .getItem(
                    "DataTables_" + window.location.pathname + "_endDateRangeRef"
                );
            if (storedEndDate != null) {
                let endDateRangStringArr = storedEndDate
                    .split(",");
                if (endDateRangStringArr.length > 1) {
                    this.endDateRangeRef[0] = new Date(endDateRangStringArr[0]);
                    this.endDateRangeRef[1] = new Date(endDateRangStringArr[1]);
                }
            }
            this.updateDateRef();
            let storedPageSize = localStorage.getItem("instanceListPageSize");
            if (storedPageSize != null) {
                this.currentPageSize = parseInt(
                    storedPageSize
                );
            }

            localStorage.removeItem("instanceList");
            localStorage.removeItem("instanceListPageSize");
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_startDateRangeRef"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_endDateRangeRef"
            );
            this.filterCount = parseInt(localStorage.getItem("setFilterDataInLocalStorage"));
            localStorage.removeItem("setFilterDataInLocalStorage");
        }
        this.selectInstanceprocess = new SlimSelect({
            select: '#process'
        });
        this.selectInstancestartedByUser = new SlimSelect({
            select: '#startedByUser'
        });
        this.selectInstanceinvolving = new SlimSelect({
            select: '#involving'
        });
        InstanceAPI.getFilterDropdownData()
            .then(result => {
                self.uniqueProcesses = result.uniqueProcesses;
                self.allUsers = result.userList;
                self.fetchCall = true;
            })

            .finally(() => {
                this.$nextTick(() => {
                    if (this.$refs.instTable.isReady) {
                        this.initInstTable();
                    } else {
                        this.$refs.instTable.addEventListener("ready", function () {
                            self.initInstTable();
                        });
                    }
                });
                self.initInstTable();
            });
    },
    methods: {
        submitDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.updateDateRef();
            this.processName = this.processNameRef;
            this.status = this.statusRef;
            this.startedBy = this.startedByRef;
            this.involving = this.involvingRef;
            this.initInstTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        flatpickr() {
            let self = this;

            self.createdDateFlatPickrInstance = flatpickr('.startFlatDiv', {
                dateFormat: 'd/M/Y',
                altInput: true,
                wrap: true,
                altFormat: 'd/m/Y',
                mode: 'range',
                defaultDate: [self.startDateRangeRef[0], self.startDateRangeRef[1]],
            });
            self.updatedDateFlatPickrInstance = flatpickr('.endFlatDiv', {
                dateFormat: 'd/M/Y',
                altInput: true,
                wrap: true,
                altFormat: 'd/m/Y',
                mode: 'range',
                defaultDate: [self.endDateRangeRef[0], self.endDateRangeRef[1]],
            });
        },
        updateDateRef() {
            let self = this;
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            if (self.startDateRangeRef.length > 0) {
                let startDateFrom = self.startDateRangeRef[0];
                let startDateTo = self.startDateRangeRef[1];
                let d = new Date(startDateFrom);
                d.setHours(0, -d.getTimezoneOffset(), 0, 0);
                this.startedAfter = d.toISOString();
                if (!startDateTo) {
                    startDateTo = startDateFrom
                }
                d = new Date(startDateTo);
                d.setHours(23, -d.getTimezoneOffset() + 59, 59, 999);
                this.startedBefore = d.toISOString();
            }
            if (self.endDateRangeRef.length > 0) {
                let endDateFrom = self.endDateRangeRef[0];
                let endDateTo = self.endDateRangeRef[1];
                let ed = new Date(endDateFrom);
                ed.setHours(0, -ed.getTimezoneOffset(), 0, 0);
                this.finishedAfter = ed.toISOString();
                if (!endDateTo) {
                    endDateTo = endDateFrom
                }
                ed = new Date(endDateTo);
                ed.setHours(23, -ed.getTimezoneOffset() + 59, 59, 999);
                this.finishedBefore = ed.toISOString();
            }
        },
        resetFilter() {
            this.updateCall = false;
            this.filterCount = 0;
            this.processName = "";
            this.processNameRef = "";
            this.status = "running";
            this.statusRef = "running";
            this.startedBy = "";
            this.startedByRef = "";
            this.involving = "";
            this.involvingRef = "";
            this.startedAfter = "";
            this.startedBefore = "";
            this.finishedAfter = "";
            this.finishedBefore = "";
            this.startDateRangeRef = [];
            this.endDateRangeRef = [];
            flatpickr("#createdDateId").destroy();
            flatpickr("#updatedDateId").destroy();
            this.flatpickr();
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.initInstTable();
            this.selectInstanceinvolving.setSelected([]);
            this.selectInstancestartedByUser.setSelected([]);
            this.selectInstanceprocess.setSelected([])
        },
        closeDialog() {
            this.updateDialog = false;
        },
        showDialog() {
            this.updateDialog = true;
        },
        getFilterCount() {
            if (this.selectedLabelRef != "")
                this.filterCount += 1;
            if (this.applicationNameRef != "")
                this.filterCount += 1;
            if (this.deployedRef != "")
                this.filterCount += 1;
            if (this.disabledRef != "")
                this.filterCount += 1;
            if (this.protectedRef != "")
                this.filterCount += 1;
        },
        filterTable(e) {
            this.filterCount = 0;
            this.getFilterCount();
            this.selectedLabels = this.selectedLabelRef;
            this.applicationName = this.applicationNameRef;
            this.deployedType = this.deployedRef;
            this.disabledType = this.disabledRef;
            this.protectedType = this.protectedRef;
            this.initApplicationsTable();
        },
        updateOrderList(filteredApplicationList) {
            this.filterData = filteredApplicationList;
            this.filterActive = true;
            this.initInstTable();

        },
        filterFunctionList(filteredRows, filterValue) {

            this.processName = filterValue;
            this.initInstTable();
            this.processName = "";
            return filteredRows.filter(function (f) {
                return (

                    f.processDefinitionName.toString().toLowerCase().includes(filterValue.toLowerCase()) ||

                    f.startUserId.toLowerCase().includes(filterValue.toLowerCase())

                );
            })
        },
        handleStartRangeChange(e) {
            this.startDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.startDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleStartRangeReady() {
            if (this.startDateRangeRef.length > 1) {
                this.$refs.startDate.value =
                    moment(this.startDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.startDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        handleEndRangeChange(e) {
            this.endDateRangeRef = "";
            if (e.target.value.length > 1) {
                this.endDateRangeRef = e.target.value.split(' to ');
            }
        },
        handleEndRangeReady() {
            if (this.endDateRangeRef.length > 1) {
                this.$refs.endDate.value =
                    moment(this.endDateRangeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.endDateRangeRef[1]).format("DD/MM/YYYY");
            }
        },
        showFilterDialog() {
            this.$refs.filterDialog.show();
        },
        updateTemplate() {
            let self = this;
            this.$refs.instTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let procInstId = $(targetEle).attr("data-procInstId");
                            self.$router.push(
                                self.CONTEXT_PATH +
                                "/processengine/processes/processinstance/" + procInstId.trim() + "/all"
                            );
                        }
                    });
                });
        },
        initInstTable() {
            let self = this;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const filesTable = document.querySelector('#instTableId');
            this.tableObj = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No process instances found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        processDefinitionName: {
                            type: "string",
                            title: "Process",
                            template: '<a class="name-link" data-procInstId="{{processInstanceId}}">{{processDefinitionName}}</a>',
                            sortable: false,
                            columnSearch: false
                        },
                        startUserId: {
                            type: "string",
                            title: "Started by",
                            sortable: false,
                            columnSearch: false
                        },
                        prettyStartTime: {
                            type: "string",
                            title: "Started",
                            sortable: true,
                            template: '<div class="dateTemplate"><u>{{prettyStartTime}}</u><div>{{startTimeObject}}</div></div>',
                            columnSearch: false
                        },
                        prettyEndTime: {
                            type: "string",
                            title: "Completed",
                            sortable: true,
                            template: '<div class="dateTemplate"><u>{{prettyEndTime}}</u><div>{{endTimeObject}}</div></div>',
                            columnSearch: false
                        },
                        prettyDurationInMillis: {
                            type: "string",
                            title: "Duration",
                            template: '<div class="dateTemplate"><u>{{prettyDurationInMillis}}</u><div>{{durationInMillis}}</div></div>',
                            sortable: true,
                            columnSearch: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "startTime";
                        }
                        if (sortDirection == null) {
                            sortDirection = "desc";
                        }
                        if (sortHeader == "prettyStartTime") {
                            sortHeader = "startTime";
                        } else if (sortHeader == "prettyEndTime") {
                            sortHeader = "endTime";
                        } else if (sortHeader == "prettyDurationInMillis") {
                            sortHeader = "duration";
                        }
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&includeVariables=false";
                        if (self.processName != "") {
                            queryString += "&processDefinitionName=" + self.processName;
                        }
                        if (self.startedBy != "") {
                            queryString += "&startedBy=" + encodeURI(self.startedBy);
                        }
                        if (self.involving != "") {
                            queryString += "&involvedUser=" + encodeURI(self.involving);
                        }
                        if (self.startedAfter != "") {
                            queryString +=
                                "&startedAfter=" +
                                self.startedAfter +
                                "&startedBefore=" +
                                this.startedBefore;
                        }
                        if (self.finishedAfter != "") {
                            queryString +=
                                "&finishedAfter=" +
                                self.finishedAfter +
                                "&finishedBefore=" +
                                self.finishedBefore;
                        }
                        if (self.status == "running") {
                            queryString = queryString + "&finished=false";
                        } else if (self.status == "completed") {
                            queryString = queryString + "&finished=true";
                        }

                        return InstanceAPI.getProcessInsatnces(queryString, []).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.recordsTotal;
                            if (result.data != null) {
                                result.data.forEach(element => {
                                    element['startTimeObject'] = (element.startTimeInDate != null) ?
                                        Utils.getMomentDateString(element.startTimeInDate) : '';

                                    element['endTimeObject'] = (element.endTimeInDate != null) ?
                                        Utils.getMomentDateString(element.endTimeInDate) : '';

                                    element['durationInMillis'] = (element.durationInMillis != null) ?
                                        element.durationInMillis + ' ms' : '';
                                });
                                responseData.data = result.data;

                            }
                            self.tableData = responseData.data;
                            self.updateCall = true;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_processName",
                this.processName
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_status",
                this.status
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_startedBy",
                this.startedBy
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_involving",
                this.involving
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_startDateRangeRef",
                this.startDateRangeRef
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_endDateRangeRef",
                this.endDateRangeRef
            );
            localStorage.setItem("applicationListFilterCount", this.filterCount);
        }
    }
};
</script>

<style scoped>
.flatpickr-calendar {
    top: 2%;
}
</style>
